import React from 'react';
import { companyInfo } from '../data/mock';
import { Phone, MapPin, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Inicio', href: '#inicio' },
    { label: 'Propiedades', href: '#propiedades' },
    { label: 'Servicios', href: '#servicios' },
    { label: 'Contacto', href: '#contacto' },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#050505] text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24 py-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-20 w-auto mb-8"
              data-testid="footer-logo"
            />
            <p className="text-white/40 leading-relaxed mb-8 max-w-md" style={{ fontFamily: 'Outfit, sans-serif' }}>
              {companyInfo.description}
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                data-testid="footer-facebook"
                className="w-10 h-10 border border-[#D4A520]/20 flex items-center justify-center hover:bg-[#D4A520] hover:border-[#D4A520] transition-all duration-300 group"
              >
                <Facebook className="w-5 h-5 text-white/50 group-hover:text-black" />
              </a>
              <a
                href="#"
                data-testid="footer-instagram"
                className="w-10 h-10 border border-[#D4A520]/20 flex items-center justify-center hover:bg-[#D4A520] hover:border-[#D4A520] transition-all duration-300 group"
              >
                <Instagram className="w-5 h-5 text-white/50 group-hover:text-black" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-8 text-[#D4A520]">Enlaces Rápidos</h4>
            <ul className="space-y-4">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-white/40 hover:text-[#D4A520] transition-colors duration-300 text-sm uppercase tracking-wider"
                    style={{ fontFamily: 'Outfit, sans-serif' }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-8 text-[#D4A520]">Contacto</h4>
            <ul className="space-y-5">
              <li>
                <a
                  href={`tel:${companyInfo.phone1}`}
                  className="flex items-center gap-3 text-white/40 hover:text-[#D4A520] transition-colors duration-300"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  <Phone className="w-4 h-4 text-[#D4A520]/50" />
                  <span className="text-sm">{companyInfo.phone1}</span>
                </a>
              </li>
              <li>
                <a
                  href={`tel:${companyInfo.phone2}`}
                  className="flex items-center gap-3 text-white/40 hover:text-[#D4A520] transition-colors duration-300"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  <Phone className="w-4 h-4 text-[#D4A520]/50" />
                  <span className="text-sm">{companyInfo.phone2}</span>
                </a>
              </li>
              <li>
                <div className="flex items-center gap-3 text-white/40" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  <MapPin className="w-4 h-4 text-[#D4A520]/50" />
                  <span className="text-sm">{companyInfo.address}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#D4A520]/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-white/20 text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>
              © {currentYear} {companyInfo.name} {companyInfo.tagline}. Todos los derechos reservados.
            </p>
            <p className="text-white/20 text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Diseñado con dedicación para nuestros clientes
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
